<script setup lang="ts">
import { CheckboxIndicator, CheckboxRoot, type CheckboxRootProps } from 'radix-vue'
import CheckIcon from '@/assets/check.svg'
import { computed, type HTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<CheckboxRootProps & { class?: HTMLAttributes['class'] }>(),
  {}
)

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <CheckboxRoot
    v-bind="delegatedProps"
    class="flex h-6 w-6 items-center justify-center rounded border-[2px] border-solid border-light-grey data-[state=checked]:border-check"
  >
    <CheckboxIndicator class="h-full w-full flex items-center justify-center bg-check">
      <check-icon />
    </CheckboxIndicator>
  </CheckboxRoot>
</template>
